import React from 'react';
import {Button, Card, Col, Row, Statistic, Tooltip} from 'antd';
const ReCreditParameterTable = (props) => (
    <Card title="Re-Credit Parameters">
      {Object.keys(props.dataSource).length ? <Row gutter={16}>
        <Col span={12} className={'statistic-header-color'}>
            <Tooltip title="If Percentage Retailer Invoices in PAR30+ In Last 12 months is greater than 25%, then buyer not applicable for recredit.">
            <span><h4>% retailer invoices in PAR30+ in last 12 months</h4></span>
            </Tooltip>

          <label>{Number(props.dataSource['perc_retailer_invoice_in_par_30_in_last_12_month']).toFixed(2)}</label>
        </Col>
        <Col span={12} className={'statistic-header-color'}>
            <Tooltip title=" If number of Re-Credit For Buyer in Last 12 months is equal to 3, then buyer not applicable for recredit.">
            <span><h4>No. of Re-Credit For Buyer in Last 12 months</h4></span>
            </Tooltip>

          <label>{props.dataSource['max_count_of_buyer_recredit_in_last_12_months']}</label>
        </Col>
        <div style={{marginTop: "45px", display: "inline-block", width: "100%"}}>
          <Col span={12}>
              <Tooltip title="If Any Of The Seller is Misaligned Or Terminated, then buyer not applicable for recredit.">
                <span><h4>Seller Misaligned Or Terminated</h4></span>
              </Tooltip>
            {props.dataSource && Object.keys(props.dataSource['seller_misaligned_or_terminated']).map(_ => {
              return <>
                <p>{_} - {props.dataSource['seller_misaligned_or_terminated'][_] ? "Yes" : "No"}</p>
              </>
            })}
          </Col>
          <Col span={12}>
              <Tooltip title="If Any Of The Seller Porfolio overdue is greater than 30%, then buyer not applicable for recredit.">
                <span><h4>Seller Overdue %</h4></span>
              </Tooltip>
            {props.dataSource && Object.keys(props.dataSource['db_overdue']).map(_ =>
                <p>{_} - {props.dataSource['db_overdue'][_]}</p>
            )}
          </Col>
        </div>
      </Row> :<></>}
    </Card>
);
export default ReCreditParameterTable;